export enum NotificationType {
    Success = 1,
    Error = 2,
    Warning = 3,
    Info = 4
}

export interface NotificationIdsViewModel {
    notifications: number[]
}

export interface NotificationPostViewModel {
    notificationType: NotificationType;
    notificationContentType: "Text" | "Html";
    title: string;
    rawContent: string;
    content: string;
    pinned: boolean;
    toDepartmentIds: number[];
    toUserIds: number[];
}

export interface MyNotifications {
    notifications: NotificationModel[]
}

export interface NotificationModel {
    id: number;
    date: string;
    title: string;
    type: NotificationType;
    viewed: boolean;
    read: boolean;
    pinned: boolean;
    content: string;
    author: string;
    isActive: boolean;
    departments: DepartmentModel[];
}

export interface NotificationRequest {
    notificationType?: NotificationType;
    isRead?: boolean;
    search?: string;
    pageIndex?: number;
    pageSize?: number;
    sort?: string;
    order?: string;
}

export interface DepartmentModel {
    id: number;
    name: number;
}

export interface NotificationResponse {
    data: NotificationModel[];
    totalItems: number;
}